<template>
  <div class="main-content-container container-fluid h-100" style="padding:0px !important;">
    <div class="header-Panel btn-accent">
     
      <label
        style="padding:20px; padding-left:5px; font-weight:500; font-size:20px !important;"
      >Shop The World</label>
    </div>
    <div class="row h-80 no-gutters">
      <div class="auth-form mx-auto my-auto col-md-6 col-lg-4">
        <div class="card">
          <d-card-header class="border-bottom">
             
            <strong class="s2" style="font-size:25px">Login</strong>
          </d-card-header>
          <div class="card-body">
            <!---->
            <!---->
            <!-- <img rc="/demo/shards-dashboard-vue/img/shards-dashboards-logo.60a85991.svg" alt="Dev Tools - Login Template" class="auth-form__logo d-table mx-auto mb-3"/> -->
            <!-- <h5 class="auth-form__title text-center mb-4"> Login </h5> -->
            <div class>
              <div class="form-group">
                <label for="exampleInputEmail1">User Name</label>
                <input
                  id="exampleInputEmail1"
                  v-model="Login.DataModel.Data.UserName"
                  autocomplete="off"
                  type="text"
                  placeholder="User Name"
                  class="form-control"
                />
              </div>
              <div class="form-group">
                <label for="exampleInputPassword1">Password</label>
                <input
                  style="width:100% !important"
                  id="exampleInputPassword1"
                  v-model="Login.DataModel.Data.Password"
                  type="password"
                  placeholder="Password"
                  class="form-control"
                />
              </div>

              <!-- <div class="form-group mb-3 d-table mx-auto">
                <label class="custom-control custom-checkbox">
                  <input
                    type="checkbox"
                    autocomplete="off"
                    id="dr-checkbox-916cfc04-2baf-469b-a56a-26ccbea8ce08"
                    true-value="orange"
                    class="custom-control-input"
                    value="orange"
                  />
                  <label
                    for="dr-checkbox-916cfc04-2baf-469b-a56a-26ccbea8ce08"
                    aria-hidden="true"
                    class="custom-control-label"
                  ></label>
                  <span class="custom-control-description">Remember me for 30 days.</span>
                </label>
              </div>-->
              <button
                @click="login()"
                class="btn btn-pill btn-accent d-table mx-auto"
              >Access Account</button>
              <!-- <div class="form-group">
                            <label for="email">Type in the characters displayed in the box below</label>
                              <img src="" id="captcha_image" />
                            <input type="text" class="form-control" required id="captcha" name="captcha">
              </div>-->
              <!-- <div class="row">
                            <button type="submit" @click="loginClick()" class="btn btn-pill btn-accent d-table mx-auto">Submit</button>
                            <button type="submit" class="btn btn-pill btn-accent d-table mx-auto">Reset</button>
              </div>-->
            </div>
          </div>
          <div class="border-top card-footer">
            <div class="auth-form__meta d-flex">
              <!-- <a style="color: rgb(0, 123, 255); cursor:pointer;" @click="forgetpasswordClick()" target="_self" >Forgot your password?</a> -->
              <!-- <a style="color: rgb(0, 123, 255)" @click="forgetpasswordClick()" target="_self">Forgot your password?</a> -->
              <!-- <span style="color: #007bff" target="_self"  v-on:click="forgetpasswordClick()" >Forgot your password?</span> -->
              <!-- <a href="#" @click="Register()" class="ml-auto" target="_self">Registration</a> -->
            </div>
          </div>
        </div>
        <div class="auth-form__meta d-flex mt-4">
          <!-- <a style="color: rgb(0, 123, 255)" @click="forgetpasswordClick()" target="_self">Forgot your password?</a> -->
          <!-- <span style="color: #007bff" target="_self"  v-on:click="forgetpasswordClick()" >Forgot your password?</span> -->
          <!-- <a href="/demo/shards-dashboard-vue/register" class="ml-auto" target="_self" >Create a new account?</a> -->
        </div>
      </div>
    </div>
  </div>
</template>

<script src="https://checkout.razorpay.com/v1/checkout.js"></script>
<script>
import LoginService from "../../Services/Application/Login.js";
import Utilities from "@/Utilities/Utilities";
import axios from "axios";
export default {
  name: "Login",
  data() {
    return {
      Login: {
        PageType: "Master", // Master, Transaction, Dashboard, Tabb edDashboard
        PageLoad: true, // block/none
        DataModel: {
          Data: {
            UserId: 0,
            UserName: null,
            Password: null,
            CreatedBy: null,
          },
          UIData: {},
        },
        PageState: "Default", // Default, Changed/Dirty, Submitted, PageLoading Dirty means some values are changed in the page
        TabInfo: {
          SelectedTabIndex: 0,
          NumberOfTabs: 0,
        },
        SessionInfo: {
          SessionTimeout: false,
          AuthToken: "",
          SessionID: "",
          PageInfo: {
            ClientId: 0,
            userId: 0,
            WareHouseId: 0,
          },
        },
        GridInfo: {},
        Events: {
          EventRaised: "Submitted", // Saved, Submitted, Cancelled, AutoCompletionTextChanged,
          PageToNavigateWhenSubmitted: "", // We can go back to dashboard or stay on the Same page or to a specific page
        },
        ValidationInfo: {},
        ErrorInfo: [
          {
            ErrorID: 1,
            ErrorName: "",
            ErrorMessage: "",
          },
        ],
        Masters: {},
        Modal: {},
        CharRestrict: {},
      },
    };
  },
  mounted() {},
  methods: {
    login() {
      let vm = this;
      if (
        Utilities.IsNotNullOrEmptyOrUndefined(
          vm.Login.DataModel.Data.UserName
        ) ||
        Utilities.IsNotNullOrEmptyOrUndefined(vm.Login.DataModel.Data.Password)
      ) {
        this.Login.DataModel.Data.CreatedBy = new Date();
        this.Login.DataModel.Data.CRUD = "login";

        var dataString = JSON.stringify(this.Login.DataModel.Data);
        axios
          .post("APIScript/PHP/APIService/Login/Login.php", dataString)
          .then(function (response) {
            if (response.data.ErrorInfo == null) {
              sessionStorage.setItem(
                "LoginTime",
                response.data.Result.CreatedBy
              );
              sessionStorage.setItem(
                "CustomerId",
                response.data.Result.CustomerId
              );
              //  sessionStorage.setItem(
              //                 "RegisterId",
              //                 response.data.Result.RegisterId
              //               );
              sessionStorage.setItem(
                "FirstName",
                response.data.Result.FirstName
              );
              sessionStorage.setItem("LastName", response.data.Result.LastName);

              sessionStorage.setItem("Token", response.data.Result.Token);
              sessionStorage.setItem("UserName", response.data.Result.UserName);
              sessionStorage.setItem("UserId", response.data.Result.UserId);
              vm.$toaster.success("Login Successfully.");
              Utilities.gotoRoute(vm, "/Generic-Upload");
            } else {
              if (
                !Utilities.IsNotNullOrEmptyOrUndefined(
                  vm.Login.DataModel.Data.UserName
                ) ||
                !Utilities.IsNotNullOrEmptyOrUndefined(
                  vm.Login.DataModel.Data.Password
                )
              ) {
                console.log(response.data.ErrorInfo);
                vm.$swal.fire(
                  "Information missing",
                  "Please provid Username and password ",
                  "error"
                );
              } else {
                console.log(response.data.ErrorInfo);
                vm.$swal.fire(
                  "Oops...",
                  "Incorrect User name or password !",
                  "error"
                );
              }
            }
          })
          .catch(function (response) {
            console.log(response);
            vm.$swal.fire("Oops", "Something went worng", "error");
          });
      } else {
        vm.$swal.fire(
          "Information missing",
          "Please provid Username and password ",
          "error"
        );
      }
    },
    forgetpasswordClick() {
      Utilities.gotoRoute(this, "/ForgotPassword");
    },
    Register() {
      Utilities.gotoRoute(this, "/Registration");
    },
    Pay() {
      console.log("test");
      var options = {
        key: "YOUR_KEY_ID",
        amount: "2000", // 2000 paise = INR 20
        name: "Merchant Name",
        description: "Purchase Description",
        image: "/your_logo.png",
        handler: function (response) {
          alert(response.razorpay_payment_id);
        },
        prefill: {
          name: "Gaurav Kumar",
          email: "test@test.com",
        },
        notes: {
          address: "Hello World",
        },
        theme: {
          color: "#F37254",
        },
      };
      var rzp1 = new Razorpay(options);
      rzp1.open();
    },
  },
};
</script>

<style scoped>
.header-Panel {
  /* background-color:#00ff9c ; */
  /* #00ff9c */
}

.h-80 {
  height: 80% !important;
}
</style>
